import { IHoliday } from "../holidayTypes";

export const AustraliaHolidays: { [key: string]: IHoliday } = {

// 2025
"2025-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2025-01-26": { title: "Australia Day", type: "HOLIDAY" },
"2025-01-27": { title: "Australia Day (observed)", type: "HOLIDAY" }, // When Jan 26 falls on weekend
"2025-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
"2025-03-10": { title: "Labour Day", type: "HOLIDAY" }, // VIC, TAS
"2025-04-18": { title: "Good Friday", type: "HOLIDAY" },
"2025-04-19": { title: "Saturday before Easter Sunday", type: "HOLIDAY" },
"2025-04-20": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2025-04-21": { title: "Easter Monday", type: "HOLIDAY" },
"2025-04-25": { title: "Anzac Day", type: "HOLIDAY" },
"2025-05-05": { title: "Labour Day", type: "HOLIDAY" }, // QLD
"2025-05-11": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2025-06-02": { title: "Western Australia Day", type: "HOLIDAY" }, // WA
"2025-06-09": { title: "King's Birthday", type: "HOLIDAY" }, // All except WA, QLD
"2025-06-15": { title: "Father's Day", type: "SPECIAL_DAY" },
"2025-08-04": { title: "Picnic Day", type: "HOLIDAY" }, // NT
"2025-09-01": { title: "Father's Day", type: "SPECIAL_DAY" }, // Australia celebrates in September
"2025-09-29": { title: "King's Birthday", type: "HOLIDAY" }, // WA
"2025-10-06": { title: "Labour Day", type: "HOLIDAY" }, // ACT, NSW, SA
"2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2025-11-04": { title: "Melbourne Cup Day", type: "HOLIDAY" }, // VIC (Melbourne metro)
"2025-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2025-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2025-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2025-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

// 2026
"2026-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2026-01-26": { title: "Australia Day", type: "HOLIDAY" },
"2026-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
"2026-03-09": { title: "Labour Day", type: "HOLIDAY" }, // VIC, TAS
"2026-04-03": { title: "Good Friday", type: "HOLIDAY" },
"2026-04-04": { title: "Saturday before Easter Sunday", type: "HOLIDAY" },
"2026-04-05": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2026-04-06": { title: "Easter Monday", type: "HOLIDAY" },
"2026-04-25": { title: "Anzac Day", type: "HOLIDAY" },
"2026-05-04": { title: "Labour Day", type: "HOLIDAY" }, // QLD
"2026-05-10": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2026-06-01": { title: "Western Australia Day", type: "HOLIDAY" }, // WA
"2026-06-08": { title: "King's Birthday", type: "HOLIDAY" }, // All except WA, QLD
"2026-08-03": { title: "Picnic Day", type: "HOLIDAY" }, // NT
"2026-09-06": { title: "Father's Day", type: "SPECIAL_DAY" },
"2026-09-28": { title: "King's Birthday", type: "HOLIDAY" }, // WA
"2026-10-05": { title: "Labour Day", type: "HOLIDAY" }, // ACT, NSW, SA
"2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2026-11-03": { title: "Melbourne Cup Day", type: "HOLIDAY" }, // VIC (Melbourne metro)
"2026-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2026-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2026-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2026-12-28": { title: "Boxing Day (observed)", type: "HOLIDAY" }, // When Dec 26 falls on weekend
"2026-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

// 2027
"2027-01-01": { title: "New Year's Day", type: "HOLIDAY" },
"2027-01-26": { title: "Australia Day", type: "HOLIDAY" },
"2027-02-14": { title: "Valentine's Day", type: "SPECIAL_DAY" },
"2027-03-08": { title: "Labour Day", type: "HOLIDAY" }, // VIC, TAS
"2027-03-26": { title: "Good Friday", type: "HOLIDAY" },
"2027-03-27": { title: "Saturday before Easter Sunday", type: "HOLIDAY" },
"2027-03-28": { title: "Easter Sunday", type: "SPECIAL_DAY" },
"2027-03-29": { title: "Easter Monday", type: "HOLIDAY" },
"2027-04-25": { title: "Anzac Day", type: "HOLIDAY" },
"2027-04-26": { title: "Anzac Day (observed)", type: "HOLIDAY" }, // When Apr 25 falls on Sunday in some states
"2027-05-03": { title: "Labour Day", type: "HOLIDAY" }, // QLD
"2027-05-09": { title: "Mother's Day", type: "SPECIAL_DAY" },
"2027-06-07": { title: "Western Australia Day", type: "HOLIDAY" }, // WA
"2027-06-14": { title: "King's Birthday", type: "HOLIDAY" }, // All except WA, QLD
"2027-08-02": { title: "Picnic Day", type: "HOLIDAY" }, // NT
"2027-09-05": { title: "Father's Day", type: "SPECIAL_DAY" },
"2027-09-27": { title: "King's Birthday", type: "HOLIDAY" }, // WA
"2027-10-04": { title: "Labour Day", type: "HOLIDAY" }, // ACT, NSW, SA
"2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
"2027-11-02": { title: "Melbourne Cup Day", type: "HOLIDAY" }, // VIC (Melbourne metro)
"2027-12-24": { title: "Christmas Eve", type: "SPECIAL_DAY" },
"2027-12-25": { title: "Christmas Day", type: "HOLIDAY" },
"2027-12-26": { title: "Boxing Day", type: "HOLIDAY" },
"2027-12-27": { title: "Christmas Day (observed)", type: "HOLIDAY" }, // When Dec 25 falls on weekend
"2027-12-28": { title: "Boxing Day (observed)", type: "HOLIDAY" }, // When Dec 26 falls on weekend
"2027-12-31": { title: "New Year's Eve", type: "SPECIAL_DAY" },

};



// WEBPACK FOOTER //
// ./src/constants/holidays/usa/australiaHolidays.ts